/**
 * HTTP request layer
 * if auth is required return patched axios instance(with access token in headers)
 * else return clear axios instance
 */
import Vue from "vue";
import axios from "axios";
import $store from "../store";
import { StatusCodes, getReasonPhrase } from "http-status-codes";
import { AuthService } from "./auth.service";
import $router from "../router";

let API_URL = process.env.VUE_APP_API_URL;

export class Http {
  constructor(configs = {}) {
    this.showLoader = configs.showLoader ? configs.showLoader : true;
    this.isAuth = configs.auth ? configs.auth : false;

    let requestConfigs = {
      baseURL: API_URL
    };

    if (configs.headers) requestConfigs.headers = configs.headers;

    if (configs.responseType)
      requestConfigs.responseType = configs.responseType;

    this.instance = axios.create(requestConfigs);
    return this.init();
  }

  init() {
    this.instance.interceptors.request.use(
      request => {
        if (this.showLoader) this.showLoading();
        if (this.isAuth) {
          request.headers.authorization = AuthService.getBearer();
        }
        return request;
        // if access token expired and refreshToken is exist >> go to API and get new access token
        // if (AuthService.isAccessTokenExpired() && AuthService.hasRefreshToken()) {
        //   return AuthService.debounceRefreshTokens()
        //     .then(response => {
        //       AuthService.setBearer(response.data.accessToken)
        //       request.headers.authorization = AuthService.getBearer()
        //       return request
        //     }).catch(error => Promise.reject(error))
        // } else {
        //   return request
        // }
      },
      error => {
        return Promise.reject(error);
      }
    );

    this.instance.interceptors.response.use(
      response => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        if (this.showLoader) this.hideLoading();
        if (response && response.status === StatusCodes.UNAUTHORIZED) {
          $store.commit("auth/DESTROY_AUTH");
          $router.push({ name: "Login" });
          // this.showUnauthorizedPopup();
        } else if (response.status > 201) {
          this.showErrorNotify(getReasonPhrase(response.status));
        }

        return response;
      },
      error => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if (
          error &&
          error.response &&
          error.response.status === StatusCodes.UNAUTHORIZED
        ) {
          $store.commit("auth/DESTROY_AUTH");
          $router.push({ name: "Login" });
          this.showUnauthorizedPopup();
        } else {
          this.showErrorNotify(_getResponseErrorMessage(error));
        }

        return Promise.reject(error).finally(() => {
          if (this.showLoader) this.hideLoading();
        });
      }
    );

    return this.instance;
  }

  get(path = "/", configs = {}) {
    return this.instance.get(path, { responseType: "json", ...configs });
  }

  post(path = "/", data = {}, configs = {}) {
    return this.instance.post(path, data, { ...configs });
  }

  put(path = "/", data = {}, configs = {}) {
    return this.instance.put(path, data, { ...configs });
  }

  delete(path = "/", configs = {}) {
    return this.instance.delete(path, { ...configs });
  }

  showUnauthorizedPopup() {
    Vue.notify({
      title: "ERROR",
      text: "Unauthorized",
      type: "error"
    });
    // setTimeout(() => $router.push({ name: "Login" }), 3000);
  }

  showErrorNotify(text) {
    Vue.notify({
      title: "Thất bại",
      text: text,
      type: "error"
    });
  }

  showLoading() {
    $store.commit("SHOW_LOADING");
  }

  hideLoading() {
    $store.commit("HIDE_LOADING");
  }
}

function _getResponseErrorMessage(error) {
  if (error.response && error.response.data && error.response.data.message)
    return error.response.data.message;
  if (error.response && error.response.statusText)
    return error.response.statusText;
  return error.message === "Network Error"
    ? "Oops! Network Error. Try again later"
    : error.message;
}
